import { TQProductList } from '~graphql/generated/clientGraphql'
import { createArray } from '~logic/helpers/arrayUtils/createArray'

type TProductCategory = TQProductList['productCategories'][number]
type TProductCategoryPlaceholder = Pick<
  TProductCategory,
  'id' | 'nameLabel' | 'descriptionLabel' | 'products'
>
type TProduct = TProductCategoryPlaceholder['products'][number]

const getPlaceholderProductItems = (itemCount: number) => {
  const placeholderItems: RoA<TProduct> = createArray({
    length: itemCount,
    mappingFunction: (index) => {
      return {
        id: `${index}`,
        nameLabel: `name label placeholder`,
        descriptionLabel: `description placeholder`,
        price: { value: 0, formattedValue: `0 CZK` },
        allergens: [],
        image: null,
        pictogram: null,
        availableAddonCount: 0,
        productTags: [],
        isSoldOut: false,
        isCombinationMeal: false,
      }
    },
  })

  return placeholderItems
}

/**
 * generates fake product categories populated with fake items with the same structure as the real data
 * that can be used to render categories with loading skeletons before the data arrives
 * @param categoryItemCounts array of lengths of product categories, each value represents one product category and determines how many products it will contain
 *
 */
export const getProductListPlaceholders = (categoryItemCounts: RoA<number>) => {
  const placeholders: RoA<TProductCategoryPlaceholder> = categoryItemCounts.map(
    (categoryLength, index) => {
      return {
        id: `${index}`,
        nameLabel: `name label placeholder`,
        descriptionLabel: null,
        products: getPlaceholderProductItems(categoryLength),
      }
    },
  )

  return placeholders
}
